import { render, staticRenderFns } from "./superMindmap.vue?vue&type=template&id=b2f8f0cc&"
import script from "./superMindmap.vue?vue&type=script&lang=js&"
export * from "./superMindmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports